import { TEMPLATES } from './templates'

export default function TemplateBuilder({ data, onChange, disabled }) {
  const templateType = data?.templateType || 'button-and-dropdown';
  const TemplateComponent = TEMPLATES[templateType];

  return <TemplateComponent data={data} onChange={onChange} disabled={disabled} />
}
